<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import { Button } from '@shared/ui/buttons/button';
  import { Select } from '@shared/ui/fields/select';
  import { TextField } from '@shared/ui/fields/text-field';
  import { Textarea } from '@shared/ui/fields/textarea';

  import type { reportConfig } from '@features/report';

  import { getReportFormData } from '../model';

  const dispatcher = createEventDispatcher();

  const sortOptions = [
    { text: 'General issue', value: 'general_issue' },
    { text: 'Technical problem', value: 'technical_problem' },
  ];

  export let formData: reportConfig.ReportForm;
  export let formAction: string | undefined = undefined;
  export let isOpen = false;

  let select: HTMLElement;

  const handleSubmit = () => {
    dispatcher('successSubmit');
  };

  const { form, errors, enhance } = getReportFormData(formData, handleSubmit);

  const handleSelectChange = (selectedOption: CustomEvent) => {
    $form.inquiry = selectedOption.detail.value;
  };

  $: if (isOpen) {
    select?.focus();
  }
</script>

<form method="POST" class="flex flex-col" use:enhance action="{formAction}">
  <div class="mb-5 flex flex-col gap-5">
    <Select
      bind:select
      on:change="{handleSelectChange}"
      state="{$errors.inquiry && 'error'}"
      helperText="{$errors.inquiry?.join(', ')}"
      name="inquiry"
      label="Type of inquiry*"
      options="{sortOptions}"
      isMargin="{false}"
    />

    <Textarea
      bind:value="{$form.message}"
      state="{$errors.message && 'error'}"
      helperText="{$errors.message?.join(', ')}"
      name="message"
      label="Leave a Message*"
      placeholder="Message"
      fieldClass="border h-24"
      noMargin
    />

    <div class="grid gap-5 md:grid md:grid-cols-2">
      <TextField
        bind:value="{$form.name}"
        state="{$errors.name && 'error'}"
        helperText="{$errors.name?.join(', ')}"
        label="Full name*"
        placeholder="John Galt"
        name="name"
        noMargin
      />

      <TextField
        bind:value="{$form.email}"
        state="{$errors.email && 'error'}"
        helperText="{$errors?.email && $errors.email[0]}"
        label="Email*"
        placeholder="johngalt@gmail.com"
        name="email"
        inputmode="email"
        noMargin
      />
    </div>
  </div>

  <p class="text-default-700 dark:text-dark-800 mb-5 text-sm">
    When submitting the form, you agree that we may use your provided data to send you emails on our updates. For
    additional info please refer to our
    <a href="/privacy-policy/" class="cursor-pointer underline"> Privacy Policy </a>.
  </p>

  <Button type="submit">Send a Report</Button>
</form>
